import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';

/**
 * Celda de licitacion de la lista de equipos.
 *
 * El precio no se guarda: se resuelve en cada consulta con la cascada
 * adjudicado > mejor oferta > estimacion manual, de modo que la estimacion que
 * teclea ingenieria nunca se pisa y sigue ahi si la licitacion se cae.
 */

const STATE_CHIPS = {
  none:       { label: 'sin pedir',    color: 'default', variant: 'outlined' },
  requested:  { label: 'pedido',       color: 'info',    variant: 'filled' },
  quoted:     { label: 'ofertas',      color: 'warning', variant: 'filled' },
  awarded:    { label: 'adjudicado',   color: 'success', variant: 'filled' },
  not_quoted: { label: 'nadie cotiza', color: 'error',   variant: 'filled' },
};

const fmtEUR = (v) => Number(v).toLocaleString('es-ES', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

export function renderQuoteCell(row) {
  const state = row.quote_state || 'none';
  const chip = STATE_CHIPS[state] || STATE_CHIPS.none;
  const label = state === 'requested' && row.requested_count > 1
    ? `pedido a ${row.requested_count}`
    : state === 'quoted' && row.quoted_count > 1
      ? `${row.quoted_count} ofertas`
      : chip.label;

  const tooltip = {
    none: 'Todavia no se ha pedido oferta de este equipo.',
    requested: `Pedido a ${row.requested_count} proveedor(es), sin respuesta con precio.`,
    quoted: `${row.quoted_count} de ${row.requested_count} lo han cotizado.`,
    awarded: `Adjudicado a ${row.awarded_supplier || 'un proveedor'}.`,
    not_quoted: 'Se ha pedido y ninguno lo cotiza: hay que pedir otra oferta.',
  }[state];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start' }}>
      <Tooltip title={tooltip || ''}>
        <Chip size="small" label={label} color={chip.color} variant={chip.variant}
          sx={{ fontSize: '0.68rem', height: 20 }} />
      </Tooltip>
      {row.cost_source === 'lump' ? (
        <Typography variant="caption" color="textSecondary">
          incluido en lote — {row.cost_supplier}
        </Typography>
      ) : row.cost_source === 'awarded' && row.current_cost != null ? (
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          {fmtEUR(row.current_cost)} EUR · {row.cost_supplier}
        </Typography>
      ) : row.cost_source === 'best_offer' && row.current_cost != null ? (
        <Tooltip title="Mejor precio recibido. Orientativo hasta que se adjudique.">
          <Typography variant="caption" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
            {fmtEUR(row.current_cost)} EUR · {row.cost_supplier}
          </Typography>
        </Tooltip>
      ) : null}
    </Box>
  );
}

export const quoteColumn = {
  field: 'quote_state',
  header: 'Licitacion',
  width: '13%',
  render: renderQuoteCell,
};
